<script lang="ts">
  import type { Snippet } from "svelte";
  import type { HTMLLabelAttributes } from "svelte/elements";

  interface Props extends HTMLLabelAttributes {
    title?: string;
    description?: string;
    align?: "left" | "top";
    visuallyHideTitle?: boolean;
    label?: Snippet;
  }

  let {
    title = "",
    description,
    align = "top",
    visuallyHideTitle = false,
    label,
    children,
    class: className,
    ...rest
  }: Props = $props();
</script>

<label
  class={[
    "flex",
    align === "left" ? "flex-row items-center justify-between gap-4" : "flex-col gap-2",
    className,
  ]}
  {...rest}
>
  <div class={["flex flex-col gap-1", visuallyHideTitle ? "sr-only" : ""]}>
    <span class="text-xs text-foreground-tertiary">
      {title}{@render label?.()}
    </span>

    {#if description}
      <span class="text-[13px] text-foreground-secondary">
        {description}
      </span>
    {/if}
  </div>
  {@render children?.()}
</label>
